export const ButtonArrowIcon = () => {
	return (
		<>
			<svg
				width="6"
				height="8"
				viewBox="0 0 6 8"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M4.55118 7.15783L1.38892 3.99994L4.55118 0.842041"
					stroke="var(--icon-color)"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</>
	)
}

export const SearchIcon = () => {
	return (
		<>
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<circle
					cx="9.38937"
					cy="9.38937"
					r="6.88937"
					stroke="var(--icon-color)"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M14.6577 14.6572L17.8998 17.8993"
					stroke="var(--icon-color)"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</>
	)
}

export const FilterIcon = () => {
	return (
		<>
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M18.3334 2.5H1.66675L8.33341 10.3833V15.8333L11.6667 17.5V10.3833L18.3334 2.5Z"
					stroke="var(--icon-color)"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</>
	)
}

export const AIPhotoshoot = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.75162 1.16887C9.13124 0.950115 9.56168 0.834961 9.99984 0.834961C10.438 0.834961 10.8685 0.950124 11.2481 1.16889L11.2498 1.1699L17.08 4.50138L17.0832 4.50322C17.4628 4.72243 17.7782 5.03762 17.9976 5.41718C18.217 5.79674 18.3327 6.22732 18.3332 6.66573V6.66658V13.3333V13.3341C18.3327 13.7725 18.217 14.2031 17.9976 14.5827C17.7782 14.9622 17.4628 15.2774 17.0832 15.4966L17.08 15.4985L11.2498 18.8299L11.2483 18.8308C10.8876 19.0387 10.481 19.1531 10.0655 19.164C10.0439 19.1657 10.0219 19.1666 9.99984 19.1666C9.97773 19.1666 9.95582 19.1657 9.93415 19.164C9.51865 19.1531 9.11206 19.0387 8.75138 18.8308L8.74984 18.8299L2.91972 15.4985L2.9165 15.4966C2.53683 15.2774 2.22148 14.9622 2.00208 14.5827C1.78268 14.2031 1.66695 13.7725 1.6665 13.3341V13.3333V6.66658V6.66573C1.66695 6.22732 1.78268 5.79674 2.00208 5.41718C2.22148 5.03762 2.53683 4.72243 2.9165 4.50323L2.91972 4.50138L2.91972 4.50138L8.75162 1.16887ZM10.8332 17.1485L16.2498 14.0532L16.2512 14.0525C16.3771 13.9794 16.4818 13.8747 16.5546 13.7486C16.6278 13.6221 16.6664 13.4785 16.6665 13.3324V7.12966L10.8332 10.4821V17.1485ZM9.1665 10.4821V17.1485L3.74984 14.0532L3.74852 14.0525C3.62255 13.9794 3.51791 13.8747 3.44503 13.7486C3.37196 13.6222 3.33338 13.4788 3.33317 13.3328V7.12961L9.1665 10.4821ZM9.99984 2.50163C9.85356 2.50163 9.70985 2.54013 9.58317 2.61327L9.57996 2.61513L9.57995 2.61512L4.18594 5.6974L9.99988 9.03874L15.8138 5.69743L10.4197 2.61512L10.4165 2.61328L10.4165 2.61327C10.2898 2.54013 10.1461 2.50163 9.99984 2.50163Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export const ClearIcon = () => {
	return (
		<>
			<svg
				width="9"
				height="9"
				viewBox="0 0 9 9"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M1.49512 7.50455L4.50032 4.49934M4.50032 4.49934L7.50553 1.49414M4.50032 4.49934L1.49512 1.49414M4.50032 4.49934L7.50552 7.50455"
					stroke="var(--icon-color)"
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
			</svg>
		</>
	)
}

export const lookAiIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M11.267 10.9331C11.0003 9.93311 9.53364 9.93311 9.26697 10.9331L8.66697 13.7998C8.46697 14.3998 9.46697 14.5998 9.60031 13.9998L9.73364 13.4664H10.9336C11.067 13.7998 11.067 14.5331 11.667 14.3998C11.9336 14.3331 12.067 14.1331 12.0003 13.8664L11.267 10.9331ZM9.86697 12.7331L10.1336 11.1998C10.1336 11.1331 10.2003 11.0664 10.267 11.0664C10.3336 11.0664 10.3336 11.1331 10.4003 11.1998L10.667 12.7331H9.86697Z"
			fill="var(--icon-color)"
		/>
		<path
			d="M12.7998 10.5996V13.9329C12.7998 14.5329 13.6665 14.5329 13.6665 13.9329V10.5996C13.6665 9.93294 12.7998 9.93294 12.7998 10.5996Z"
			fill="var(--icon-color)"
		/>
		<path
			d="M15.0669 6.19987L13.4669 3.19987C13.0002 2.19987 11.9336 1.86654 10.9336 1.5332C10.5336 3.86654 5.46689 3.86654 5.06689 1.5332C4.06689 1.86654 3.00022 2.19987 2.53355 3.19987L0.933554 6.19987C0.80022 6.39987 0.933554 6.66654 1.13355 6.7332L3.46689 7.66654C3.53355 7.7332 3.60022 7.79987 3.60022 7.86654L3.20022 14.0665C3.20022 14.2665 3.40022 14.4665 3.60022 14.4665H8.20022C7.93355 14.1332 7.86689 13.6665 7.93355 13.3332L8.53355 10.6665C8.86689 9.19987 10.9336 8.7332 11.8669 9.9332C12.0002 9.7332 12.1336 9.46654 12.4002 9.3332L12.3336 7.79987C12.3336 7.7332 12.4002 7.59987 12.4669 7.59987L14.8002 6.66654C15.0669 6.66654 15.1336 6.3332 15.0669 6.19987ZM12.0669 6.59987C11.4002 6.86654 11.1336 7.59987 11.2669 8.19987C9.66689 7.7332 7.93355 8.7332 7.53355 10.3999V10.4665L6.93355 13.0665C6.93355 13.1332 6.86689 13.2665 6.86689 13.3332H4.46689L4.80022 7.9332C4.86689 7.3332 4.46689 6.79987 3.93355 6.59987L2.33355 5.9332L3.53355 3.66654C3.73355 3.26654 4.06689 2.99987 4.46689 2.86654C5.86689 4.86654 10.0669 4.79987 11.4669 2.86654C11.8669 2.99987 12.2002 3.26654 12.4002 3.66654L13.6002 5.9332L12.0669 6.59987Z"
			fill="var(--icon-color)"
		/>
	</svg>
)

export const videoBGRemoverIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_18567_138196)">
			<path
				d="M3.52711 0.332031C3.97855 0.332031 4.19415 0.887068 3.86107 1.1918L2.49187 2.44447C2.17608 2.73338 1.66748 2.50935 1.66748 2.08134C1.66748 1.94369 1.72512 1.81233 1.82642 1.71914L3.19214 0.462678C3.28346 0.378662 3.40302 0.332031 3.52711 0.332031Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M8.00406 0.332031C8.47714 0.332031 8.70399 0.912867 8.35614 1.2335L2.53125 6.60253C2.20137 6.90659 1.66748 6.67261 1.66748 6.22397C1.66748 6.08036 1.72746 5.94328 1.83294 5.84582L7.65153 0.469957C7.74751 0.381279 7.87338 0.332031 8.00406 0.332031Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M5.71476 7.484C5.78752 7.67482 5.75692 7.89736 5.60428 8.03305L2.49758 10.7946C2.17594 11.0805 1.66748 10.8521 1.66748 10.4218C1.66748 10.2801 1.72777 10.145 1.83329 10.0504L4.95877 7.24828C5.20815 7.02469 5.59543 7.17104 5.71476 7.484Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M3.2499 12.9806C3.44674 12.8042 3.74719 12.8123 3.93415 12.9992C4.209 13.274 3.93416 13.666 3.86748 13.7326L2.49133 14.9836C2.17494 15.2712 1.66748 15.0468 1.66748 14.6192C1.66748 14.4792 1.72703 14.3458 1.83124 14.2524L3.2499 12.9806Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M9.66631 3.19531C7.93298 3.19531 6.46631 4.59531 6.46631 6.39531C6.46631 6.46198 6.46631 6.46198 6.46631 6.52865C6.46631 6.79531 6.53298 7.12865 6.59964 7.39531C6.79964 8.06198 7.26631 8.66198 7.86631 9.06198C8.19964 9.26198 8.53298 9.39531 8.86631 9.52865C9.13298 9.59531 9.39964 9.66198 9.66631 9.66198C11.3996 9.66198 12.8663 8.26198 12.8663 6.46198C12.8663 4.66198 11.3996 3.19531 9.66631 3.19531ZM9.66631 8.52865C8.46631 8.52865 7.53298 7.52865 7.53298 6.39531C7.53298 5.19531 8.53298 4.26198 9.66631 4.26198C10.7996 4.26198 11.7996 5.26198 11.7996 6.39531C11.7996 7.52865 10.8663 8.52865 9.66631 8.52865Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M5.0641 14.8668C4.73076 14.8668 4.53076 14.6001 4.53076 14.3335C4.53076 12.8668 5.13076 10.4668 9.2641 10.4668C9.34326 10.4668 9.42149 10.4677 9.49877 10.4696C9.57606 10.4677 9.65429 10.4668 9.73345 10.4668C13.8668 10.4668 14.4668 12.8668 14.4668 14.3335C14.4668 14.6001 14.2668 14.8668 13.9335 14.8668C13.9207 14.8668 13.9082 14.8665 13.8959 14.8659C13.8857 14.8665 13.8751 14.8668 13.8641 14.8668C13.5308 14.8668 13.3308 14.6001 13.3308 14.3335C13.3308 13.0711 12.8673 11.5439 9.49877 11.5335C6.13027 11.5439 5.66679 13.0711 5.66679 14.3335C5.66679 14.6001 5.46678 14.8668 5.13345 14.8668C5.12241 14.8668 5.11181 14.8665 5.10163 14.8659C5.08931 14.8665 5.0768 14.8668 5.0641 14.8668Z"
				fill="var(--icon-color)"
			/>
		</g>
		<defs>
			<clipPath id="clip0_18567_138196">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>
)

export const musicGeneratorIcon = (
	width?: string,
	height?: string,
) => (
	<svg
		width={width ? width : "20"}
		height={height ? height : "20"}
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.87023 9.72266C3.79634 9.72266 2.92578 10.5932 2.92578 11.6671C2.92578 12.741 3.79634 13.6115 4.87023 13.6115C5.94411 13.6115 6.81467 12.741 6.81467 11.6671C6.81467 10.5932 5.94411 9.72266 4.87023 9.72266ZM1.92578 11.6671C1.92578 10.0409 3.24405 8.72266 4.87023 8.72266C6.4964 8.72266 7.81467 10.0409 7.81467 11.6671C7.81467 13.2933 6.4964 14.6115 4.87023 14.6115C3.24405 14.6115 1.92578 13.2933 1.92578 11.6671Z"
			fill="var(--icon-color)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.31543 2.61072C7.59157 2.61072 7.81543 2.83458 7.81543 3.11072V11.6663C7.81543 11.9424 7.59157 12.1663 7.31543 12.1663C7.03929 12.1663 6.81543 11.9424 6.81543 11.6663V3.11072C6.81543 2.83458 7.03929 2.61072 7.31543 2.61072Z"
			fill="var(--icon-color)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.0815 2.47929C7.9425 2.57936 7.81816 2.77766 7.82034 3.10834L7.82036 3.11163L7.82035 3.83274C7.82035 4.05295 7.90885 4.31008 8.07601 4.54104C8.24296 4.7717 8.46049 4.93766 8.67076 5.00861C8.67099 5.00869 8.67123 5.00877 8.67146 5.00885L11.3703 5.90641C11.3704 5.90644 11.3701 5.90637 11.3703 5.90641C11.6892 6.01189 11.918 5.9556 12.0564 5.85572C12.1947 5.75588 12.3204 5.55677 12.3204 5.21996V4.50496C12.3204 4.28475 12.2318 4.02762 12.0647 3.79667C11.8977 3.56602 11.6802 3.40006 11.47 3.32911C11.4697 3.32903 11.4695 3.32894 11.4692 3.32886L8.76978 2.43108L8.7675 2.43032C8.45007 2.32305 8.22065 2.37912 8.0815 2.47929ZM9.08644 1.48254C8.51815 1.29085 7.9414 1.34798 7.49725 1.66772C7.05307 1.98748 6.81689 2.51568 6.82035 3.11317V3.83274C6.82035 4.30309 7.00074 4.76096 7.26594 5.12736C7.53117 5.49381 7.90917 5.80746 8.35258 5.95664L8.35423 5.95719L11.056 6.85574C11.623 7.04344 12.198 6.98679 12.6417 6.66657C13.0854 6.34627 13.3204 5.81816 13.3204 5.21996V4.50496C13.3204 4.03462 13.14 3.57675 12.8748 3.21034C12.6095 2.8439 12.2315 2.53025 11.7881 2.38107L9.08644 1.48254Z"
			fill="var(--icon-color)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.0013 12.1514V8.8243C14.979 8.19861 14.1707 8.19814 14.1481 8.8243V12.1514C14.1705 12.7771 14.9788 12.7776 15.0013 12.1514ZM12.5893 9.12852C12.442 8.65663 12.0423 8.3529 11.5718 8.35487C11.1007 8.35674 10.7034 8.66392 10.5596 9.13743C10.5564 9.14793 9.89374 12.0471 9.89374 12.0471C9.8361 12.2995 9.99339 12.5509 10.245 12.6087C10.4969 12.6665 10.7475 12.5088 10.8051 12.2564L10.9308 11.7064H12.241L12.3724 12.2602C12.4311 12.514 12.6908 12.6682 12.9354 12.6078C13.1865 12.5479 13.3418 12.2951 13.282 12.0433C13.282 12.0433 12.5925 9.13895 12.5893 9.12852ZM11.1618 10.9145L11.4676 9.33042C11.4909 9.25157 11.5313 9.20829 11.5823 9.20805H11.5828C11.6339 9.20805 11.6733 9.24957 11.697 9.32836L12.015 10.9145H11.1618Z"
			fill="var(--icon-color)"
		/>
	</svg>
)

export const generativeFillIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.75036 6.44783C9.74966 6.44816 9.74895 6.4485 9.74826 6.44883C9.73627 6.45461 9.72464 6.46114 9.71342 6.46839C9.67772 6.49148 9.64697 6.52144 9.62297 6.55653C9.59897 6.59162 9.5822 6.63114 9.57363 6.67278L9.16546 8.51161C9.07183 8.93457 8.87226 9.30086 8.59467 9.58502C8.307 9.87588 7.94184 10.078 7.54262 10.1673L5.73992 10.5837C5.68011 10.5978 5.62552 10.6286 5.5825 10.6725C5.53947 10.7164 5.50977 10.7716 5.49683 10.8317C5.4778 10.9158 5.49263 11.0041 5.53811 11.0774C5.58359 11.1507 5.65608 11.2032 5.73992 11.2235L7.54262 11.6398C7.94157 11.7297 8.3064 11.9321 8.59385 12.223C8.88111 12.5201 9.07892 12.8921 9.16463 13.2964L9.57281 15.1352C9.58566 15.1953 9.61533 15.2506 9.65837 15.2945C9.70141 15.3384 9.75604 15.3692 9.8159 15.3832C9.85739 15.3925 9.90032 15.3934 9.94216 15.3859C9.98401 15.3784 10.0239 15.3627 10.0596 15.3396C10.0953 15.3165 10.1261 15.2865 10.1501 15.2514C10.1741 15.2163 10.1909 15.1768 10.1994 15.1352L10.6076 13.2964C10.6936 12.8922 10.8913 12.5202 11.1784 12.223C11.4661 11.9321 11.8312 11.73 12.2304 11.6407L14.0323 11.2243C14.0921 11.2101 14.1467 11.1793 14.1897 11.1354C14.2328 11.0915 14.2625 11.0363 14.2754 10.9763C14.2942 10.8922 14.2793 10.8042 14.2338 10.7311C14.1883 10.658 14.116 10.6056 14.0323 10.5853L12.2304 10.1689C11.8165 10.0737 11.4568 9.87082 11.1784 9.58666C10.9 9.3025 10.7012 8.93621 10.6076 8.51326L10.1994 6.67442L10.2003 6.67278C10.1874 6.61265 10.1577 6.55741 10.1147 6.5135C10.0717 6.46959 10.017 6.43881 9.95716 6.42476C9.91567 6.41549 9.87275 6.41458 9.8309 6.42207C9.80297 6.42707 9.77589 6.43575 9.75036 6.44783ZM5.60543 6.6611C5.67496 6.50586 5.76868 6.36766 5.88282 6.25147C6.00582 6.12626 6.15327 6.02477 6.31969 5.95245C6.40107 5.91709 6.48699 5.8887 6.5768 5.86793L7.84485 5.57474C7.90466 5.5606 7.95925 5.52979 8.00227 5.48589C8.0453 5.44199 8.075 5.3868 8.08794 5.32671C8.10673 5.2427 8.09178 5.15466 8.04632 5.08155C8.00086 5.00844 7.92851 4.9561 7.84485 4.93579L6.5768 4.64342C6.48711 4.62265 6.40124 4.59424 6.31986 4.55883C6.15981 4.4892 6.01711 4.39253 5.89679 4.27384L5.88365 4.25906C5.76768 4.13917 5.67376 4.00081 5.60532 3.85039C5.60352 3.84643 5.60174 3.84247 5.59997 3.83849C5.59965 3.83776 5.59932 3.83702 5.599 3.83629C5.55866 3.74508 5.52764 3.64955 5.50668 3.55112L5.22006 2.25679C5.20721 2.19666 5.17753 2.14142 5.13449 2.09751C5.09145 2.0536 5.03682 2.02282 4.97696 2.00877C4.93547 1.9995 4.89255 1.99859 4.8507 2.00608C4.80885 2.01357 4.76891 2.02932 4.73321 2.05241C4.69752 2.07549 4.66677 2.10545 4.64277 2.14054C4.61877 2.17564 4.60199 2.21515 4.59342 2.25679L4.30598 3.55112C4.2848 3.64713 4.25533 3.73884 4.21832 3.82545C4.21659 3.82951 4.21484 3.83355 4.21307 3.83759C4.21117 3.84193 4.20925 3.84626 4.20731 3.85057C4.1406 3.99903 4.05144 4.13192 3.9438 4.2451L3.92901 4.25906C3.80613 4.3847 3.65885 4.4863 3.49287 4.55867C3.41147 4.59415 3.32558 4.62261 3.23586 4.64342L1.96781 4.93579C1.908 4.94993 1.85341 4.98074 1.81039 5.02464C1.76736 5.06853 1.73766 5.12372 1.72472 5.18381C1.70593 5.26783 1.72087 5.35587 1.76634 5.42898C1.8118 5.50209 1.88415 5.55443 1.96781 5.57474L3.23668 5.86793C3.32534 5.88778 3.41144 5.91608 3.49388 5.95224C3.65616 6.0234 3.80427 6.12497 3.92983 6.25229C4.0455 6.37215 4.13916 6.5104 4.20742 6.66065C4.20896 6.66404 4.21049 6.66743 4.212 6.67083C4.21245 6.67183 4.21289 6.67282 4.21333 6.67382C4.25385 6.76541 4.28499 6.86136 4.30598 6.96023L4.59342 8.25456C4.60627 8.31469 4.63595 8.36993 4.67899 8.41384C4.72203 8.45775 4.77666 8.48853 4.83652 8.50258C4.87801 8.51185 4.92093 8.51276 4.96278 8.50527C5.00463 8.49778 5.04457 8.48203 5.08027 8.45894C5.11596 8.43586 5.14671 8.40589 5.17071 8.3708C5.19471 8.33571 5.21149 8.2962 5.22006 8.25456L5.50668 6.96023C5.52807 6.86454 5.55746 6.77311 5.59423 6.68673C5.59621 6.68207 5.59822 6.67743 5.60025 6.6728C5.60196 6.66889 5.60369 6.66499 5.60543 6.6611ZM4.81743 5.25539C4.83831 5.27527 4.8589 5.2955 4.87919 5.31607L4.88426 5.32122L4.88929 5.32642C4.89483 5.33217 4.90035 5.33794 4.90585 5.34373C4.91439 5.3348 4.92299 5.32591 4.93167 5.31708C4.95215 5.29623 4.97294 5.27575 4.99403 5.25563C4.98275 5.24488 4.97155 5.23403 4.96044 5.22307L4.92931 5.19236L4.90691 5.16716L4.88529 5.18989L4.86048 5.21333C4.84627 5.22753 4.83192 5.24155 4.81743 5.25539ZM11.4568 4.85284C11.4697 4.91297 11.4993 4.96821 11.5424 5.01212C11.5854 5.05603 11.64 5.08681 11.6999 5.10086C11.7414 5.11013 11.7843 5.11104 11.8262 5.10355C11.868 5.09606 11.908 5.08031 11.9436 5.05723C11.9793 5.03414 12.0101 5.00418 12.0341 4.96909C12.0581 4.934 12.0749 4.89448 12.0834 4.85284L12.2723 4.00282C12.2786 3.97489 12.2861 3.94752 12.2947 3.92081C12.3116 3.86832 12.3328 3.81834 12.3582 3.77149C12.3604 3.7673 12.3627 3.76314 12.3651 3.75901C12.3947 3.70633 12.4296 3.65778 12.4691 3.61427C12.4759 3.60676 12.4829 3.59939 12.49 3.59218C12.5025 3.57951 12.5154 3.56725 12.5287 3.55544C12.5607 3.52718 12.595 3.50142 12.6316 3.47839C12.6337 3.47709 12.6357 3.47579 12.6378 3.4745C12.6881 3.44343 12.7425 3.41749 12.8003 3.39722C12.8301 3.38675 12.8608 3.3778 12.8924 3.37044L13.726 3.17826C13.7858 3.16412 13.8404 3.13331 13.8834 3.08942C13.9264 3.04552 13.9561 2.99033 13.9691 2.93024C13.9879 2.84622 13.9729 2.75818 13.9275 2.68507C13.882 2.61196 13.8097 2.55962 13.726 2.53931L12.8924 2.34713C12.8609 2.34001 12.8302 2.33125 12.8004 2.32087C12.7406 2.30001 12.6843 2.27265 12.6316 2.23908C12.6304 2.23834 12.6292 2.23759 12.6281 2.23684C12.5932 2.21434 12.5598 2.18909 12.5281 2.16118C12.5174 2.15174 12.5069 2.142 12.4965 2.13196C12.4874 2.12263 12.4785 2.1131 12.4699 2.10339C12.4301 2.05884 12.3953 2.0104 12.3659 1.95893C12.3637 1.95509 12.3615 1.95124 12.3594 1.94737C12.3328 1.89925 12.311 1.84859 12.2941 1.79606C12.2855 1.76941 12.2783 1.74228 12.2723 1.71475L12.0834 0.864735C12.0706 0.804605 12.0401 0.749364 11.9971 0.705452C11.954 0.661539 11.8994 0.630763 11.8395 0.61671C11.798 0.607443 11.7551 0.60653 11.7133 0.614022C11.6714 0.621514 11.6315 0.637262 11.5958 0.660348C11.5601 0.683433 11.5293 0.713395 11.5053 0.748486C11.4813 0.783577 11.4646 0.823094 11.456 0.864735L11.2671 1.71475C11.2612 1.7426 11.2538 1.77006 11.2452 1.79702C11.2281 1.8503 11.2058 1.90165 11.1786 1.95035C11.1771 1.9532 11.1755 1.95603 11.1738 1.95886C11.1444 2.01021 11.1096 2.05853 11.0698 2.10294C11.0653 2.10801 11.0607 2.11303 11.056 2.118C11.0416 2.13284 11.0267 2.1471 11.0113 2.16076C10.9791 2.18924 10.9449 2.21509 10.9089 2.2381C10.9063 2.23975 10.9037 2.24139 10.9011 2.24301C10.8505 2.27457 10.7965 2.30058 10.7401 2.32051C10.71 2.33114 10.6792 2.34004 10.6479 2.34713L9.81426 2.53931C9.75444 2.55346 9.69986 2.58426 9.65683 2.62816C9.61381 2.67206 9.58411 2.72725 9.57116 2.78734C9.55238 2.87136 9.56732 2.95939 9.61279 3.0325C9.65825 3.10561 9.7306 3.15795 9.81426 3.17826L10.6479 3.37044C10.6791 3.37746 10.7098 3.38626 10.7398 3.39678C10.797 3.41684 10.8518 3.44314 10.9031 3.47514C10.905 3.47631 10.9069 3.47748 10.9087 3.47867C10.945 3.50168 10.9795 3.52755 11.0119 3.55609C11.025 3.56769 11.0378 3.57972 11.0503 3.59218C11.0572 3.59943 11.0641 3.6068 11.0708 3.61428C11.1099 3.65804 11.1443 3.7056 11.1734 3.75612C11.1739 3.75707 11.1745 3.75802 11.175 3.75898C11.2043 3.81024 11.2282 3.86453 11.2462 3.92098C11.2548 3.9478 11.262 3.97512 11.2679 4.00282L11.4568 4.85284ZM9.88577 10.114C9.98828 10.2574 10.1019 10.3931 10.226 10.5198C10.365 10.6616 10.5155 10.7904 10.6759 10.9052C10.5176 11.0187 10.3685 11.1457 10.2304 11.2854L10.2248 11.291L10.2192 11.2968C10.0981 11.4222 9.98687 11.556 9.88622 11.6968C9.78535 11.5557 9.67386 11.4218 9.55242 11.2962L9.54735 11.2909L9.54223 11.2857C9.40368 11.1455 9.25406 11.018 9.0952 10.9042C9.25422 10.7904 9.40399 10.6628 9.54268 10.5226L9.54844 10.5167C9.67124 10.391 9.78388 10.2564 9.88577 10.114Z"
			fill="var(--icon-color)"
		/>
	</svg>
)

export function deforumIcon(
	width?: string,
	height?: string,
) {
	return (
		<svg
			width={width ? width : "20"}
			height={height ? height : "21"}
			viewBox="0 0 20 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.59543 1.02473C10.3515 0.892457 12.1067 1.293 13.6316 2.17401C15.1565 3.05502 16.3801 4.37552 17.1426 5.96296C17.9052 7.5504 18.1711 9.33094 17.9057 11.0719C17.8378 11.5176 17.4214 11.8238 16.9757 11.7559C16.53 11.6879 16.2238 11.2716 16.2917 10.8259C16.5076 9.40964 16.2913 7.96122 15.671 6.66988C15.0507 5.37854 14.0553 4.30435 12.8148 3.58767C11.5744 2.871 10.1466 2.54517 8.71805 2.65277C7.28951 2.76037 5.92664 3.29639 4.80755 4.19079C3.68846 5.08519 2.86518 6.29636 2.44532 7.66604C2.02545 9.03573 2.02852 10.5002 2.45412 11.8681C2.87972 13.236 3.70805 14.4438 4.83088 15.3335C5.95371 16.2232 7.31881 16.7535 8.74779 16.8551C9.1975 16.8871 9.53614 17.2775 9.50416 17.7273C9.47218 18.177 9.08169 18.5156 8.63198 18.4836C6.87534 18.3587 5.19722 17.7068 3.81693 16.6131C2.43664 15.5194 1.41836 14.0347 0.895176 12.3532C0.371988 10.6716 0.368218 8.87129 0.88436 7.18754C1.4005 5.50379 2.41255 4.0149 3.78825 2.91541C5.16395 1.81593 6.83932 1.157 8.59543 1.02473Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.27126 8.0076C8.25274 8.0183 8.08413 8.13336 8.08413 8.63071V10.8557C8.08413 11.353 8.25274 11.4681 8.27126 11.4788C8.28942 11.4893 8.47237 11.578 8.90204 11.3298C8.90213 11.3298 8.90196 11.3299 8.90204 11.3298L10.8218 10.2177C11.2514 9.9695 11.2679 9.76545 11.2679 9.74319C11.2679 9.72092 11.2523 9.51739 10.8226 9.26916L8.9023 8.15669C8.90216 8.15661 8.90243 8.15676 8.9023 8.15669C8.47273 7.90862 8.28942 7.9971 8.27126 8.0076ZM7.37248 6.45276C8.13901 6.00966 9.03867 6.16134 9.80075 6.60166L11.7211 7.71414C11.7212 7.71421 11.721 7.71406 11.7211 7.71414C12.4832 8.1546 13.0638 8.8584 13.0638 9.74319C13.0638 10.6279 12.4836 11.3315 11.7216 11.772C11.7214 11.7721 11.7217 11.7719 11.7216 11.772L9.80165 12.8842C9.03956 13.3245 8.13901 13.4767 7.37248 13.0336C6.6063 12.5907 6.28821 11.7357 6.28821 10.8557V8.63071C6.28821 7.75071 6.6063 6.89566 7.37248 6.45276Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.5681 19.5453V14.7862C19.5361 13.8913 18.3799 13.8906 18.3477 14.7862V19.5453C18.3796 20.4402 19.5359 20.4409 19.5681 19.5453ZM16.1182 15.2215C15.9075 14.5465 15.3357 14.112 14.6628 14.1149C13.9889 14.1175 13.4206 14.5569 13.215 15.2342C13.2104 15.2492 12.2626 19.3962 12.2626 19.3962C12.1801 19.7571 12.4051 20.1167 12.7651 20.1994C13.1254 20.2821 13.4837 20.0565 13.5662 19.6955L13.7459 18.9089H15.62L15.8079 19.701C15.8919 20.064 16.2634 20.2845 16.6132 20.1981C16.9725 20.1125 17.1945 19.7509 17.109 19.3907C17.109 19.3907 16.1228 15.2364 16.1182 15.2215ZM14.0761 17.7759L14.5135 15.5102C14.5468 15.3974 14.6046 15.3355 14.6776 15.3351H14.6782C14.7514 15.3351 14.8077 15.3945 14.8416 15.5072L15.2965 17.7759H14.0761Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function videoGptIcon(
	width?: string,
	height?: string,
) {
	return (
		<svg
			width={width ?? "20"}
			height={height ?? "20"}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 20"
			fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.5 11.452C13.1 12.052 13 13.052 12.2 13.452L6.6 16.752C5.1 17.652 3.3 17.052 2 14.952C2.4 17.752 5.5 19.552 8.3 17.952L13.1 15.152C15.3 13.952 15.2 10.752 13 9.552L7.5 6.452C7.7 5.652 8.6 5.252 9.4 5.652L15 8.952C16.5 9.852 17 11.652 15.9 13.652C17.9 12.452 18.5 8.752 15.4 6.952L10.4 4.052C8.2 2.752 5.6 4.252 5.7 6.752V13.352C4.9 13.652 4 13.052 4 12.152V5.652C4 3.952 5 2.352 7.7 2.352C5.1 1.152 2 3.152 2.1 6.352V12.152C2.1 14.652 4.8 16.152 6.9 14.852L12.5 11.452ZM10.6 10.352L7.5 8.652V12.152L10.6 10.352Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function scriptToAdsGenerator(
	width?: string,
	height?: string,
) {
	return (
		<svg
			width={width ?? "20"}
			height={height ?? "20"}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.9169 17.8331V14.288C17.8914 13.6214 16.9703 13.6209 16.9447 14.288V17.8331C16.9701 18.4998 17.8912 18.5003 17.9169 17.8331ZM15.1686 14.6122C15.0008 14.1094 14.5453 13.7858 14.0092 13.7879C13.4723 13.7899 13.0196 14.1172 12.8558 14.6217C12.8522 14.6329 12.0971 17.722 12.0971 17.722C12.0314 17.9909 12.2106 18.2588 12.4974 18.3204C12.7844 18.382 13.0699 18.2139 13.1356 17.945L13.2787 17.359H14.7717L14.9214 17.9491C14.9884 18.2195 15.2843 18.3838 15.563 18.3194C15.8492 18.2556 16.026 17.9863 15.9579 17.718C15.9579 17.718 15.1723 14.6233 15.1686 14.6122ZM13.5413 16.5151L13.8898 14.8272C13.9163 14.7432 13.9624 14.6971 14.0205 14.6969H14.021C14.0793 14.6969 14.1242 14.7411 14.1512 14.8251L14.5135 16.5151H13.5413Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.3335 4.16675C3.3335 2.78604 4.45278 1.66675 5.8335 1.66675H14.1668C15.5475 1.66675 16.6668 2.78604 16.6668 4.16675V11.8751C16.6668 12.3353 16.2937 12.7084 15.8335 12.7084C15.3733 12.7084 15.0002 12.3353 15.0002 11.8751V4.16675C15.0002 3.70651 14.6271 3.33341 14.1668 3.33341H5.8335C5.37326 3.33341 5.00016 3.70651 5.00016 4.16675V15.8334C5.00016 16.2937 5.37326 16.6667 5.8335 16.6667H10.0002C10.4604 16.6667 10.8335 17.0398 10.8335 17.5001C10.8335 17.9603 10.4604 18.3334 10.0002 18.3334H5.8335C4.45278 18.3334 3.3335 17.2141 3.3335 15.8334V4.16675Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M6.66699 6.66659C6.66699 6.20635 7.04009 5.83325 7.50033 5.83325H12.5003C12.9606 5.83325 13.3337 6.20635 13.3337 6.66659C13.3337 7.12682 12.9606 7.49992 12.5003 7.49992H7.50033C7.04009 7.49992 6.66699 7.12682 6.66699 6.66659Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.50033 5.83325C7.04009 5.83325 6.66699 6.20635 6.66699 6.66659C6.66699 7.12682 7.04009 7.49992 7.50033 7.49992H12.5003C12.9606 7.49992 13.3337 7.12682 13.3337 6.66659C13.3337 6.20635 12.9606 5.83325 12.5003 5.83325H7.50033Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M6.66699 9.99992C6.66699 9.53968 7.04009 9.16659 7.50033 9.16659H12.5003C12.9606 9.16659 13.3337 9.53968 13.3337 9.99992C13.3337 10.4602 12.9606 10.8333 12.5003 10.8333H7.50033C7.04009 10.8333 6.66699 10.4602 6.66699 9.99992Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.50033 9.16659C7.04009 9.16659 6.66699 9.53968 6.66699 9.99992C6.66699 10.4602 7.04009 10.8333 7.50033 10.8333H12.5003C12.9606 10.8333 13.3337 10.4602 13.3337 9.99992C13.3337 9.53968 12.9606 9.16659 12.5003 9.16659H7.50033Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M6.74268 13.3333C6.74268 12.873 7.11577 12.4999 7.57601 12.4999H10.076C10.5362 12.4999 10.9093 12.873 10.9093 13.3333C10.9093 13.7935 10.5362 14.1666 10.076 14.1666H7.57601C7.11577 14.1666 6.74268 13.7935 6.74268 13.3333Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.57601 12.4999C7.11577 12.4999 6.74268 12.873 6.74268 13.3333C6.74268 13.7935 7.11577 14.1666 7.57601 14.1666H10.076C10.5362 14.1666 10.9093 13.7935 10.9093 13.3333C10.9093 12.873 10.5362 12.4999 10.076 12.4999H7.57601Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function aiScriptGenerator(
	width?: string,
	height?: string,
) {
	return (
		<svg
			width={width ?? "20"}
			height={height ?? "20"}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.3335 15.8333C3.3335 17.214 4.45278 18.3333 5.8335 18.3333H14.1668C15.5475 18.3333 16.6668 17.214 16.6668 15.8333V8.12492C16.6668 7.66468 16.2937 7.29159 15.8335 7.29159C15.3733 7.29159 15.0002 7.66468 15.0002 8.12492V15.8333C15.0002 16.2935 14.6271 16.6666 14.1668 16.6666H5.8335C5.37326 16.6666 5.00016 16.2935 5.00016 15.8333V4.16659C5.00016 3.70635 5.37326 3.33325 5.8335 3.33325H10.0002C10.4604 3.33325 10.8335 2.96016 10.8335 2.49992C10.8335 2.03968 10.4604 1.66659 10.0002 1.66659H5.8335C4.45278 1.66659 3.3335 2.78588 3.3335 4.16659V15.8333Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M6.66699 13.3334C6.66699 13.7937 7.04009 14.1667 7.50033 14.1667H12.5003C12.9606 14.1667 13.3337 13.7937 13.3337 13.3334C13.3337 12.8732 12.9606 12.5001 12.5003 12.5001H7.50033C7.04009 12.5001 6.66699 12.8732 6.66699 13.3334Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.50033 14.1667C7.04009 14.1667 6.66699 13.7937 6.66699 13.3334C6.66699 12.8732 7.04009 12.5001 7.50033 12.5001H12.5003C12.9606 12.5001 13.3337 12.8732 13.3337 13.3334C13.3337 13.7937 12.9606 14.1667 12.5003 14.1667H7.50033Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M6.66699 10.0001C6.66699 10.4603 7.04009 10.8334 7.50033 10.8334H12.5003C12.9606 10.8334 13.3337 10.4603 13.3337 10.0001C13.3337 9.53984 12.9606 9.16675 12.5003 9.16675H7.50033C7.04009 9.16675 6.66699 9.53984 6.66699 10.0001Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.50033 10.8334C7.04009 10.8334 6.66699 10.4603 6.66699 10.0001C6.66699 9.53984 7.04009 9.16675 7.50033 9.16675H12.5003C12.9606 9.16675 13.3337 9.53984 13.3337 10.0001C13.3337 10.4603 12.9606 10.8334 12.5003 10.8334H7.50033Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M6.74268 6.66675C6.74268 7.12699 7.11577 7.50008 7.57601 7.50008H10.076C10.5362 7.50008 10.9093 7.12699 10.9093 6.66675C10.9093 6.20651 10.5362 5.83342 10.076 5.83342H7.57601C7.11577 5.83342 6.74268 6.20651 6.74268 6.66675Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.57601 7.50008C7.11577 7.50008 6.74268 7.12699 6.74268 6.66675C6.74268 6.20651 7.11577 5.83342 7.57601 5.83342H10.076C10.5362 5.83342 10.9093 6.20651 10.9093 6.66675C10.9093 7.12699 10.5362 7.50008 10.076 7.50008H7.57601Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M13.8041 2.28321L12.3655 1.86736C12.2989 1.84758 12.2281 1.84713 12.1612 1.86606C12.0944 1.88499 12.0343 1.92252 11.988 1.97429C11.9564 2.01042 11.9323 2.05249 11.9171 2.09805C11.9018 2.1436 11.8959 2.19173 11.8994 2.23962C11.903 2.28751 11.9161 2.3342 11.9379 2.37699C11.9598 2.41977 11.9899 2.45778 12.0265 2.4888L13.1547 3.47397C13.3918 3.68046 13.5588 3.93427 13.647 4.20852L13.6528 4.23073C13.7395 4.51364 13.7439 4.82143 13.6591 5.12604L13.2632 6.54173C13.2448 6.6087 13.2459 6.6795 13.2661 6.74591C13.2864 6.81232 13.325 6.87163 13.3776 6.91697C13.4508 6.98105 13.5462 7.01384 13.6433 7.0083C13.7404 7.00276 13.8314 6.95932 13.8968 6.88734L14.8739 5.78757C15.0747 5.55845 15.3372 5.39198 15.63 5.30805C15.9268 5.22645 16.2406 5.22988 16.5355 5.31794L17.9746 5.73297C18.0412 5.75275 18.112 5.75321 18.1789 5.73427C18.2457 5.71534 18.3058 5.67781 18.3521 5.62605C18.3837 5.58991 18.4078 5.54784 18.423 5.50229C18.4382 5.45673 18.4442 5.40861 18.4406 5.36072C18.4371 5.31282 18.424 5.26613 18.4022 5.22335C18.3803 5.18056 18.3502 5.14255 18.3136 5.11153L17.185 4.12718C16.9418 3.91425 16.7714 3.65325 16.6856 3.37079C16.5997 3.08832 16.5954 2.78053 16.6806 2.47511L17.0757 1.05897C17.094 0.991999 17.093 0.921204 17.0727 0.854791C17.0525 0.788379 17.0138 0.729068 16.9612 0.683732C16.888 0.619655 16.7926 0.586858 16.6956 0.5924C16.5985 0.597942 16.5074 0.641379 16.442 0.713364L15.4662 1.81277C15.2612 2.04334 15.0076 2.20409 14.7319 2.28725L14.7101 2.29228C14.4132 2.37428 14.0993 2.37113 13.8041 2.28321Z"
				fill="#85889E"
			/>
		</svg>
	)
}

export function productUrlToAdsIcon(
	width?: string,
	height?: string,
) {
	return (
		<svg
			width={width ?? "20"}
			height={height ?? "20"}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.90325 10.1077C8.16863 10.4797 8.5203 10.7777 8.93442 10.9815C9.34853 11.1853 9.8154 11.2901 10.3034 11.2888C10.7913 11.2876 11.2889 11.1803 11.7625 10.9742C12.236 10.7682 12.6744 10.4681 13.0479 10.0945L15.2585 7.88402C15.9312 7.19081 16.3412 6.29879 16.4 5.40008C16.4589 4.50138 16.162 3.66789 15.5732 3.07913C14.9845 2.49038 14.151 2.19346 13.2523 2.25234C12.3536 2.31122 11.4616 2.72118 10.7684 3.39393L9.50151 4.65443"
				stroke="var(--icon-color)"
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.749 8.53223C10.4837 8.16024 10.132 7.86225 9.71787 7.65845C9.30376 7.45466 8.83689 7.34983 8.34893 7.35108C7.86097 7.35233 7.36335 7.45962 6.8898 7.66569C6.41625 7.87176 5.97785 8.17177 5.60435 8.54539L3.39384 10.7559C2.7211 11.4491 2.31114 12.3411 2.25226 13.2398C2.19338 14.1385 2.49029 14.972 3.07904 15.5608C3.6678 16.1495 4.50129 16.4465 5.4 16.3876C6.2987 16.3287 7.19072 15.9187 7.88393 15.246L9.14392 13.986"
				stroke="var(--icon-color)"
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.4275 13.0985C15.2502 12.5302 14.7687 12.1644 14.2022 12.1668C13.6348 12.169 13.1563 12.5389 12.9832 13.1092C12.9794 13.1218 12.1813 16.6132 12.1813 16.6132C12.1119 16.9171 12.3013 17.2199 12.6044 17.2895C12.9077 17.3591 13.2095 17.1692 13.2789 16.8653L13.4302 16.203H15.008L15.1663 16.8699C15.237 17.1755 15.5498 17.3611 15.8443 17.2884C16.1468 17.2163 16.3337 16.9119 16.2617 16.6086C16.2617 16.6086 15.4314 13.111 15.4275 13.0985ZM13.7082 15.2492L14.0765 13.3416C14.1045 13.2466 14.1532 13.1945 14.2146 13.1942H14.2152C14.2768 13.1942 14.3241 13.2442 14.3527 13.3391L14.7357 15.2492H13.7082ZM18.3321 16.7389V12.7321C18.3052 11.9786 17.3317 11.9781 17.3046 12.7321V16.7389C17.3315 17.4924 18.3049 17.493 18.3321 16.7389Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function aiAdsGenratorIcon(
	width?: string,
	height?: string,
) {
	return (
		<svg
			width={width ?? "20"}
			height={height ?? "20"}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.9887 2.40454L13.55 1.9887C13.4835 1.96892 13.4126 1.96846 13.3458 1.9874C13.279 2.00633 13.2189 2.04386 13.1726 2.09562C13.1409 2.13176 13.1168 2.17383 13.1016 2.21938C13.0864 2.26494 13.0804 2.31306 13.084 2.36095C13.0876 2.40884 13.1007 2.45554 13.1225 2.49832C13.1443 2.54111 13.1744 2.57912 13.2111 2.61014L14.3392 3.5953C14.5764 3.8018 14.7434 4.05561 14.8316 4.32985L14.8374 4.35207C14.924 4.63498 14.9284 4.94277 14.8437 5.24738L14.4477 6.66307C14.4294 6.73004 14.4304 6.80084 14.4507 6.86725C14.4709 6.93366 14.5096 6.99297 14.5622 7.03831C14.6354 7.10238 14.7308 7.13518 14.8279 7.12964C14.9249 7.1241 15.016 7.08066 15.0814 7.00867L16.0585 5.9089C16.2592 5.67978 16.5217 5.51331 16.8146 5.42939C17.1114 5.34779 17.4251 5.35122 17.7201 5.43928L19.1592 5.85431C19.2258 5.87409 19.2966 5.87454 19.3634 5.85561C19.4303 5.83668 19.4903 5.79915 19.5367 5.74738C19.5683 5.71125 19.5924 5.66918 19.6076 5.62362C19.6228 5.57807 19.6288 5.52994 19.6252 5.48205C19.6216 5.43416 19.6085 5.38747 19.5867 5.34468C19.5649 5.3019 19.5348 5.26389 19.4981 5.23287L18.3696 4.24852C18.1264 4.03558 17.9559 3.77459 17.8701 3.49213C17.7843 3.20966 17.7799 2.90187 17.8651 2.59644L18.2603 1.18031C18.2786 1.11334 18.2776 1.04254 18.2573 0.976129C18.237 0.909716 18.1984 0.850406 18.1458 0.80507C18.0726 0.740993 17.9772 0.708196 17.8801 0.713738C17.783 0.71928 17.692 0.762717 17.6266 0.834702L16.6508 1.9341C16.4457 2.16468 16.1922 2.32543 15.9164 2.40859L15.8947 2.41362C15.5978 2.49562 15.2839 2.49247 14.9887 2.40454Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.33464 4.40527C2.93534 4.40527 2.41797 4.82792 2.41797 5.6078V15.3704C2.41797 16.1503 2.93534 16.573 3.33464 16.573H16.668C17.0673 16.573 17.5846 16.1503 17.5846 15.3704L17.5846 9.23563C17.5846 8.82142 17.9204 8.48563 18.3346 8.48563C18.7488 8.48563 19.0846 8.82142 19.0846 9.23563L19.0846 15.3704C19.0846 16.7473 18.1096 18.073 16.668 18.073H3.33464C1.89298 18.073 0.917969 16.7473 0.917969 15.3704V5.6078C0.917969 4.23098 1.89298 2.90527 3.33464 2.90527H10.8267C11.2409 2.90527 11.5767 3.24106 11.5767 3.65527C11.5767 4.06949 11.2409 4.40527 10.8267 4.40527H3.33464Z"
				fill="var(--icon-color)"
				stroke="var(--icon-color)"
				strokeWidth="0.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.1934 13.6812C10.7402 13.6812 10.4746 13.4077 10.4746 12.9312V8.79443C10.4746 8.31787 10.7402 8.04443 11.1934 8.04443H12.7637C14.4668 8.04443 15.4668 9.03271 15.4668 10.8296C15.4668 12.6304 14.4629 13.6812 12.7637 13.6812H11.1934ZM11.9082 12.5249H12.5762C13.5098 12.5249 14.0098 11.9585 14.0098 10.8335C14.0098 9.7749 13.4824 9.20068 12.5762 9.20068H11.9082V12.5249Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M5.26367 13.7671C4.81055 13.7671 4.5332 13.5093 4.5332 13.0835C4.5332 12.9624 4.57227 12.7866 4.63477 12.6147L6.02539 8.79443C6.23242 8.22021 6.58008 7.9585 7.13867 7.9585C7.72852 7.9585 8.07227 8.2085 8.28711 8.79443L9.68945 12.6147C9.75586 12.7983 9.7832 12.9312 9.7832 13.0796C9.7832 13.4819 9.48242 13.7671 9.06445 13.7671C8.65039 13.7671 8.43555 13.5796 8.31055 13.1187L8.11914 12.4937H6.18945L5.99805 13.0952C5.86133 13.5718 5.64648 13.7671 5.26367 13.7671ZM6.47461 11.4116H7.80664L7.14648 9.23975H7.11523L6.47461 11.4116Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function galleryIcon() {
	return (
		<svg
			width="21"
			height="21"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.1871 7.29292C17.455 7.56075 17.5485 7.95692 17.4287 8.31625L15.3087 14.6763C15.2092 14.9749 14.9749 15.2092 14.6763 15.3087L8.31625 17.4287C7.95692 17.5485 7.56075 17.455 7.29292 17.1871C7.02509 16.9193 6.93157 16.5231 7.05134 16.1638L9.17134 9.8038C9.27088 9.50519 9.50519 9.27088 9.8038 9.17134L16.1638 7.05134C16.5231 6.93157 16.9193 7.02509 17.1871 7.29292ZM10.9106 10.9106L9.58117 14.8989L13.5695 13.5695L14.8989 9.58117L10.9106 10.9106Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9505 1H12.0495C13.8768 0.999992 15.3162 0.999985 16.4701 1.10456C17.6481 1.21133 18.6263 1.43338 19.5 1.93782C20.5641 2.5522 21.4478 3.43587 22.0622 4.5C22.5666 5.37372 22.7887 6.35191 22.8954 7.52993C23 8.6838 23 10.1232 23 11.9505V12.0495C23 13.8768 23 15.3162 22.8954 16.4701C22.7887 17.6481 22.5666 18.6263 22.0622 19.5C21.4478 20.5641 20.5641 21.4478 19.5 22.0622C18.6263 22.5666 17.6481 22.7887 16.4701 22.8954C15.3162 23 13.8768 23 12.0495 23H11.9505C10.1232 23 8.6838 23 7.52993 22.8954C6.35191 22.7887 5.37372 22.5666 4.5 22.0622C3.43587 21.4478 2.5522 20.5641 1.93782 19.5C1.43338 18.6263 1.21133 17.6481 1.10456 16.4701C0.999985 15.3162 0.999992 13.8768 1 12.0495V11.9505C0.999992 10.1232 0.999985 8.68379 1.10456 7.52993C1.21133 6.35191 1.43338 5.37372 1.93782 4.5C2.5522 3.43587 3.43587 2.5522 4.5 1.93782C5.37372 1.43338 6.35191 1.21133 7.52993 1.10456C8.68379 0.999985 10.1232 0.999992 11.9505 1ZM7.71045 3.0964C6.67116 3.19059 6.01859 3.37047 5.5 3.66987C4.7399 4.10872 4.10872 4.7399 3.66987 5.5C3.37047 6.01859 3.19059 6.67116 3.0964 7.71045C3.00096 8.7635 3 10.1124 3 12C3 13.8876 3.00096 15.2365 3.0964 16.2895C3.19059 17.3288 3.37047 17.9814 3.66987 18.5C4.10872 19.2601 4.7399 19.8913 5.5 20.3301C6.01859 20.6295 6.67116 20.8094 7.71045 20.9036C8.7635 20.999 10.1124 21 12 21C13.8876 21 15.2365 20.999 16.2895 20.9036C17.3288 20.8094 17.9814 20.6295 18.5 20.3301C19.2601 19.8913 19.8913 19.2601 20.3301 18.5C20.6295 17.9814 20.8094 17.3288 20.9036 16.2895C20.999 15.2365 21 13.8876 21 12C21 10.1124 20.999 8.7635 20.9036 7.71045C20.8094 6.67116 20.6295 6.01859 20.3301 5.5C19.8913 4.7399 19.2601 4.10872 18.5 3.66987C17.9814 3.37047 17.3288 3.19059 16.2895 3.0964C15.2365 3.00096 13.8876 3 12 3C10.1124 3 8.7635 3.00096 7.71045 3.0964Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function closeIcon() {
	return (
		<svg
			width="30"
			height="30"
			viewBox="0 0 30 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g filter="url(#filter0_d_14526_87645)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.06511 6.17059C7.54209 5.64756 6.6941 5.64756 6.17108 6.17059C5.64805 6.69361 5.64805 7.5416 6.17108 8.06462L13.1061 14.9996L6.17108 21.9346C5.64805 22.4576 5.64805 23.3056 6.17108 23.8287C6.6941 24.3517 7.54209 24.3517 8.06511 23.8287L15.0001 16.8937L21.9351 23.8287C22.4581 24.3517 23.3061 24.3517 23.8291 23.8287C24.3522 23.3056 24.3522 22.4576 23.8291 21.9346L16.8941 14.9996L23.8291 8.06462C24.3522 7.5416 24.3522 6.69361 23.8291 6.17059C23.3061 5.64756 22.4581 5.64756 21.9351 6.17059L15.0001 13.1056L8.06511 6.17059Z"
					fill="var(--icon-color)"
				/>
			</g>
			<defs>
				<filter
					id="filter0_d_14526_87645"
					x="-3"
					y="-3"
					width="36"
					height="36"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB">
					<feFlood
						floodOpacity="0"
						result="BackgroundImageFix"
					/>
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="1.5" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_14526_87645"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_14526_87645"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	)
}

export function newCloseIcon(
	width?: string,
	height?: string,
) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width ? width : "24"}
			height={height ? height : "24"}
			viewBox="0 0 24 24"
			fill="none">
			<path
				d="M5.07107 19.2117L19.2132 5.06956M5.07107 5.06956L19.2132 19.2117"
				stroke="var(--icon-color)"
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	)
}

export function moreIcon() {
	return (
		<svg
			width="28"
			height="28"
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.0555 20.8056C12.0555 21.875 12.9305 22.75 14 22.75C15.0694 22.75 15.9444 21.875 15.9444 20.8056C15.9444 19.7361 15.0694 18.8611 14 18.8611C12.9305 18.8611 12.0555 19.7361 12.0555 20.8056Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M12.0555 7.19447C12.0555 8.26392 12.9305 9.13892 14 9.13892C15.0694 9.13892 15.9444 8.26392 15.9444 7.19447C15.9444 6.12503 15.0694 5.25003 14 5.25003C12.9305 5.25003 12.0555 6.12503 12.0555 7.19447Z"
				fill="var(--icon-color)"
			/>
			<path
				d="M12.0555 14C12.0555 15.0695 12.9305 15.9445 14 15.9445C15.0694 15.9445 15.9444 15.0695 15.9444 14C15.9444 12.9306 15.0694 12.0556 14 12.0556C12.9305 12.0556 12.0555 12.9306 12.0555 14Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function globusIcon() {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<circle
				cx="12"
				cy="12"
				r="9.75"
				stroke="var(--icon-color)"
				strokeWidth="1.5"
			/>
			<path
				d="M15.9055 12C15.9055 14.8199 15.3972 17.3368 14.6063 19.1206C14.2105 20.0135 13.7585 20.6895 13.2945 21.1322C12.8344 21.5711 12.3982 21.75 12.0001 21.75C11.602 21.75 11.1659 21.5711 10.7057 21.1322C10.2417 20.6895 9.78977 20.0135 9.39389 19.1206C8.60299 17.3368 8.09473 14.8199 8.09473 12C8.09473 9.18009 8.60299 6.6632 9.39389 4.87936C9.78977 3.98647 10.2417 3.31043 10.7057 2.86781C11.1659 2.42885 11.602 2.25 12.0001 2.25C12.3982 2.25 12.8344 2.42885 13.2945 2.86781C13.7585 3.31043 14.2105 3.98647 14.6063 4.87936C15.3972 6.6632 15.9055 9.18009 15.9055 12Z"
				stroke="var(--icon-color)"
				strokeWidth="1.5"
			/>
			<path
				d="M2.60742 12H21.3933"
				stroke="var(--icon-color)"
				strokeWidth="1.5"
			/>
		</svg>
	)
}

export function restyleIcon(
	width?: string,
	height?: string,
) {
	return (
		<svg
			width={width ? width : "20"}
			height={height ? height : "20"}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.98969 18.1324V13.5897C6.9592 12.7354 5.85553 12.7348 5.82478 13.5897V18.1324C5.85527 18.9867 6.95894 18.9874 6.98969 18.1324ZM3.69661 14.0052C3.49555 13.3609 2.94974 12.9462 2.30739 12.9488C1.66411 12.9514 1.12165 13.3708 0.925378 14.0173C0.921038 14.0317 0.0162514 17.9901 0.0162514 17.9901C-0.0624506 18.3346 0.152305 18.6779 0.4959 18.7568C0.839814 18.8358 1.18191 18.6204 1.26061 18.2759L1.43215 17.525H3.22105L3.40044 18.2811C3.48064 18.6276 3.83522 18.838 4.16914 18.7556C4.51207 18.6738 4.72398 18.3287 4.64237 17.9849C4.64237 17.9849 3.70105 14.0194 3.69661 14.0052ZM1.74733 16.4435L2.16487 14.2807C2.19666 14.1731 2.25183 14.114 2.32149 14.1136H2.32212C2.39197 14.1136 2.44567 14.1703 2.47809 14.2779L2.91224 16.4435H1.74733Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.09102 5.97377C2.09102 4.84207 2.32319 4.38133 2.61526 4.13847C2.95927 3.85241 3.64315 3.63991 5.08224 3.63991H10.9399C12.3789 3.63991 13.0628 3.85241 13.4068 4.13847C13.6989 4.38133 13.9311 4.84207 13.9311 5.97377V12.463C13.9311 13.5926 13.6976 14.0542 13.404 14.2978C13.0584 14.5847 12.3735 14.7969 10.9399 14.7969H8.19999V16.6184H10.9399C12.4258 16.6184 13.6919 16.426 14.5674 15.6995C15.4949 14.9296 15.7526 13.7689 15.7526 12.463V5.97377C15.7526 4.67007 15.4982 3.50848 14.5715 2.73788C13.6967 2.01047 12.4296 1.81836 10.9399 1.81836H5.08224C3.59251 1.81836 2.32539 2.01047 1.45062 2.73788C0.523893 3.50848 0.26947 4.67007 0.26947 5.97377V11.8238C0.704339 11.2711 1.34905 10.9101 2.09102 10.8648V5.97377Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.2383 5.97209C17.2381 5.97224 17.2385 5.97193 17.2383 5.97209L15.6856 7.21768V11.213L17.2395 12.4596L17.2413 12.461C17.4653 12.6419 17.5852 12.6583 17.6261 12.6567C17.6524 12.6212 17.7279 12.49 17.7279 12.1274V6.31093C17.7279 5.9443 17.6507 5.81364 17.6247 5.7794C17.5848 5.77707 17.4644 5.79161 17.2383 5.97209ZM17.64 5.78192C17.64 5.782 17.639 5.78177 17.6371 5.78099ZM17.6425 12.6542C17.6425 12.6543 17.6415 12.6547 17.6393 12.6552ZM18.3252 4.35507C18.9698 4.7401 19.1963 5.54266 19.1963 6.31093V12.1274C19.1963 12.8949 18.9702 13.6992 18.3237 14.0832C17.6636 14.4754 16.9333 14.2156 16.3734 13.764C16.3731 13.7637 16.3737 13.7642 16.3734 13.764L14.5188 12.2762C14.3293 12.1241 14.2172 11.8816 14.2172 11.6236V6.80709C14.2172 6.54908 14.3293 6.3066 14.5188 6.15456L16.3742 4.6661C16.9354 4.21779 17.6668 3.96186 18.3252 4.35507Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function photoAiIcon(
	width?: string,
	height?: string,
) {
	return (
		<svg
			width={width ? width : "20"}
			height={height ? height : "20"}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M5.9019 7.15768C6.77009 7.15768 7.4739 6.45387 7.4739 5.58568C7.4739 4.71748 6.77009 4.01367 5.9019 4.01367C5.03371 4.01367 4.3299 4.71748 4.3299 5.58568C4.3299 6.45387 5.03371 7.15768 5.9019 7.15768Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.3537 18.7797V13.7827C19.3202 12.843 18.1061 12.8423 18.0723 13.7827V18.7797C18.1058 19.7194 19.3199 19.7201 19.3537 18.7797ZM15.7313 14.2397C15.5101 13.531 14.9098 13.0748 14.2032 13.0778C13.4956 13.0806 12.8989 13.5419 12.683 14.2531C12.6782 14.2689 11.6829 18.6231 11.6829 18.6231C11.5963 19.0021 11.8326 19.3797 12.2105 19.4665C12.5888 19.5534 12.9651 19.3165 13.0517 18.9375L13.2404 18.1115H15.2082L15.4055 18.9432C15.4937 19.3244 15.8838 19.5559 16.2511 19.4652C16.6283 19.3752 16.8614 18.9956 16.7717 18.6174C16.7717 18.6174 15.7362 14.2554 15.7313 14.2397ZM13.5871 16.9219L14.0464 14.5428C14.0814 14.4244 14.1421 14.3594 14.2187 14.359H14.2194C14.2962 14.359 14.3553 14.4214 14.3909 14.5397L14.8685 16.9219H13.5871Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.26483 2.13373C3.45154 0.947031 5.20653 0.515137 7.39247 0.515137H12.4341C14.6201 0.515137 16.3751 0.947031 17.5618 2.13373C18.7485 3.32043 19.1804 5.07543 19.1804 7.26137V9.81863V9.8219V11.8049C19.0841 11.7889 18.9855 11.7807 18.8852 11.7806C18.3049 11.7805 17.7815 12.0558 17.4503 12.5123C17.4513 12.4436 17.4518 12.3738 17.4518 12.303V10.2107L16.3989 9.2844L16.3989 9.28438C16.0811 9.00476 15.5294 9.00476 15.2116 9.28438L15.2113 9.28464L11.7757 12.3047L11.7754 12.3049C10.8047 13.1587 9.2753 13.1586 8.30474 12.3047L8.29739 12.2982L8.29743 12.2982L8.02919 12.0567C7.74572 11.81 7.24426 11.7763 6.9124 12.0041L6.91214 12.0043L2.84055 14.8045C2.79801 14.8337 2.75378 14.8586 2.70838 14.8793C2.89654 15.4498 3.1599 15.8812 3.48712 16.2084C4.19104 16.9123 5.37702 17.3207 7.39247 17.3207H10.65L10.3807 18.498C10.3383 18.6833 10.3252 18.8687 10.3382 19.0493H7.39247C5.20653 19.0493 3.45154 18.6174 2.26483 17.4307C1.07813 16.244 0.64624 14.489 0.64624 12.303V7.26137C0.64624 5.07543 1.07813 3.32043 2.26483 2.13373ZM17.4518 7.26137V7.912C16.4788 7.13343 15.0116 7.15822 14.0701 7.98636L14.0697 7.98663L10.6342 11.0067L10.6339 11.0069C10.3171 11.2857 9.76782 11.2865 9.44956 11.0095L9.18134 10.7681L9.18137 10.768L9.17409 10.7616C8.28428 9.97855 6.90511 9.91176 5.93314 10.5797L5.93289 10.5799L2.39337 13.0141C2.38107 12.7893 2.37481 12.5525 2.37481 12.303V7.26137C2.37481 5.24592 2.78319 4.05994 3.48712 3.35602C4.19104 2.65209 5.37702 2.24371 7.39247 2.24371H12.4341C14.4496 2.24371 15.6356 2.65209 16.3395 3.35602C17.0434 4.05994 17.4518 5.24592 17.4518 7.26137Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function textToImageIcon(
	width?: string,
	height?: string,
) {
	return (
		<svg
			width={width ? width : "20"}
			height={height ? height : "20"}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.77701 15.6575C5.26551 15.7092 5.63622 16.1212 5.63622 16.6124V17.9263C5.63622 18.4515 6.2208 18.7649 6.65777 18.4738L6.65827 18.4735L10.6039 15.8489C10.7615 15.7441 10.9465 15.6882 11.1358 15.6882H14.6296C15.9584 15.6882 17.0446 15.2464 17.7981 14.4929C18.5515 13.7395 18.9934 12.6532 18.9934 11.3245V5.7689C18.9934 4.44014 18.5515 3.35385 17.7981 2.60042C17.0446 1.84698 15.9584 1.40514 14.6296 1.40514H5.37034C4.04158 1.40514 2.9553 1.84698 2.20186 2.60042C1.44843 3.35385 1.00659 4.44014 1.00659 5.7689V11.3245C1.00659 12.6532 1.44843 13.7395 2.20186 14.4929C2.84198 15.1331 3.71811 15.5454 4.77701 15.6575Z"
				stroke="var(--icon-color)"
				strokeWidth="1.92063"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19.2591 7.68555L14.9384 10.8849C13.5176 11.937 11.6316 12.1177 10.0369 11.3545V11.3545C8.50731 10.6225 6.70427 10.7568 5.30007 11.7073L1.6665 14.167"
				stroke="var(--icon-color)"
				strokeWidth="1.92063"
				strokeMiterlimit="10"
				strokeLinejoin="round"
			/>
			<path
				d="M12.101 7.49099C13.059 7.49099 13.8357 6.71432 13.8357 5.75624C13.8357 4.79816 13.059 4.02148 12.101 4.02148C11.1429 4.02148 10.3662 4.79816 10.3662 5.75624C10.3662 6.71432 11.1429 7.49099 12.101 7.49099Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function generateIcon() {
	return (
		<svg
			width="16"
			height="20"
			viewBox="0 0 16 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.7488 8.343L11.259 10.6415C11.3761 11.1702 11.6245 11.6281 11.9725 11.9833C12.3205 12.3385 12.7702 12.5921 13.2876 12.7111L15.5399 13.2316C15.6445 13.257 15.7349 13.3224 15.7918 13.4138C15.8486 13.5052 15.8673 13.6153 15.8438 13.7203C15.8276 13.7954 15.7905 13.8644 15.7367 13.9193C15.6829 13.9741 15.6147 14.0126 15.5399 14.0303L13.2876 14.5508C12.7885 14.6624 12.3321 14.9151 11.9725 15.2787C11.6137 15.6503 11.3665 16.1152 11.259 16.6204L10.7488 18.9189C10.7381 18.971 10.7171 19.0204 10.6871 19.0643C10.6571 19.1081 10.6187 19.1456 10.5741 19.1744C10.5294 19.2033 10.4795 19.223 10.4272 19.2323C10.3749 19.2417 10.3213 19.2406 10.2694 19.229C10.1946 19.2114 10.1263 19.1729 10.0725 19.1181C10.0187 19.0632 9.98158 18.9941 9.96552 18.9189L9.4553 16.6204C9.34816 16.115 9.1009 15.6501 8.74182 15.2787C8.38251 14.9151 7.92648 14.6621 7.42778 14.5498L5.17441 14.0293C5.06961 14.0039 4.979 13.9383 4.92215 13.8467C4.86529 13.7551 4.84676 13.6448 4.87054 13.5396C4.88672 13.4645 4.92385 13.3955 4.97763 13.3406C5.03141 13.2858 5.09964 13.2473 5.17441 13.2296L7.42778 12.7091C7.92681 12.5975 8.38327 12.3448 8.74285 11.9812C9.08984 11.626 9.3393 11.1682 9.45633 10.6395L9.96655 8.34095C9.97726 8.2889 9.99823 8.2395 10.0282 8.19564C10.0582 8.15177 10.0967 8.11432 10.1413 8.08546C10.1859 8.0566 10.2358 8.03692 10.2881 8.02755C10.3404 8.01819 10.3941 8.01933 10.446 8.03092C10.5208 8.04848 10.5891 8.08695 10.6429 8.14184C10.6967 8.19673 10.7338 8.26578 10.7498 8.34095L10.7488 8.343ZM13.1038 1.08089L13.3399 2.14341C13.3823 2.34019 13.4795 2.52098 13.6202 2.66492C13.7588 2.7994 13.9241 2.89077 14.115 2.93389L15.157 3.17411C15.2616 3.1995 15.352 3.26492 15.4088 3.35631C15.4657 3.4477 15.4843 3.55774 15.4609 3.66277C15.4447 3.73788 15.4076 3.80687 15.3538 3.86174C15.3 3.91661 15.2318 3.95512 15.157 3.9728L14.115 4.21302C13.9169 4.25922 13.7444 4.35572 13.612 4.4902C13.4795 4.62468 13.3851 4.80228 13.3399 5.0035L13.1038 6.06602C13.0931 6.11807 13.0721 6.16747 13.0421 6.21133C13.0121 6.25519 12.9737 6.29264 12.9291 6.3215C12.8844 6.35036 12.8345 6.37004 12.7822 6.37941C12.7299 6.38877 12.6763 6.38763 12.6244 6.37605C12.5496 6.35848 12.4813 6.32001 12.4275 6.26512C12.3737 6.21023 12.3366 6.14118 12.3205 6.06602L12.0844 5.0035C12.0434 4.81035 11.9492 4.63254 11.8124 4.4902C11.6744 4.35197 11.4999 4.25583 11.3093 4.21302L10.2673 3.9728C10.1628 3.94741 10.0723 3.88198 10.0155 3.7906C9.95866 3.69921 9.93998 3.58916 9.96347 3.48414C9.97964 3.40903 10.0168 3.34004 10.0706 3.28517C10.1243 3.2303 10.1926 3.19179 10.2673 3.17411L11.3093 2.93389C11.5036 2.88993 11.6809 2.79041 11.8195 2.64747C11.9519 2.50671 12.0431 2.33238 12.0834 2.14341L12.3195 1.08089C12.3302 1.02884 12.3512 0.97944 12.3812 0.935577C12.4112 0.891714 12.4496 0.854261 12.4942 0.825404C12.5389 0.796547 12.5888 0.776862 12.6411 0.767497C12.6934 0.758132 12.747 0.759274 12.7989 0.770857C12.8737 0.788424 12.942 0.826894 12.9958 0.881784C13.0496 0.936675 13.0877 1.00573 13.1038 1.08089ZM4.52458 2.82096L4.88286 4.43887C4.95384 4.7722 5.11712 5.07884 5.35407 5.32379L5.37049 5.34227C5.59737 5.56607 5.8879 5.72724 6.22051 5.80424L7.80557 6.1697C7.91015 6.19509 8.00058 6.26052 8.05741 6.35191C8.11424 6.44329 8.13292 6.55334 8.10944 6.65836C8.09326 6.73347 8.05613 6.80246 8.00235 6.85733C7.94857 6.91221 7.88034 6.95071 7.80557 6.96839L6.22051 7.33489C5.87866 7.41393 5.58197 7.58127 5.35304 7.8143C5.12411 8.04734 4.96088 8.35121 4.88286 8.70025L4.52458 10.3182C4.51387 10.3702 4.4929 10.4196 4.4629 10.4635C4.4329 10.5073 4.39447 10.5448 4.34984 10.5736C4.30522 10.6025 4.2553 10.6222 4.20299 10.6316C4.15068 10.6409 4.09703 10.6398 4.04516 10.6282C3.97034 10.6106 3.90205 10.5722 3.84825 10.5173C3.79445 10.4624 3.75735 10.3933 3.74129 10.3182L3.38198 8.70025C3.31125 8.36706 3.14833 8.06044 2.9118 7.81533C2.67511 7.57532 2.37431 7.40852 2.04536 7.33489L0.459277 6.96839C0.354698 6.94301 0.264263 6.87758 0.207434 6.78619C0.150604 6.6948 0.131922 6.58476 0.155406 6.47974C0.171582 6.40462 0.208713 6.33564 0.262494 6.28076C0.316276 6.22589 0.384506 6.18738 0.459277 6.1697L2.04434 5.80424C2.38516 5.72519 2.68185 5.55786 2.91078 5.32379L2.92926 5.30634C3.14895 5.07536 3.30704 4.77867 3.38198 4.43887L3.74129 2.82096C3.752 2.76891 3.77297 2.71951 3.80297 2.67565C3.83297 2.63179 3.87141 2.59433 3.91603 2.56548C3.96065 2.53662 4.01058 2.51693 4.06289 2.50757C4.1152 2.4982 4.16885 2.49935 4.22071 2.51093C4.29554 2.5285 4.36383 2.56697 4.41763 2.62186C4.47143 2.67675 4.50852 2.7458 4.52458 2.82096Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function textToVideoIcon() {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.21823 19.1844L11.1244 16.5861H14.5833C16.1145 16.5861 17.444 16.0727 18.3924 15.1243C19.3407 14.176 19.8541 12.8465 19.8541 11.3153V5.81527C19.8541 4.28403 19.3407 2.95458 18.3924 2.00621C17.444 1.05785 16.1145 0.544434 14.5833 0.544434H5.41665C3.88541 0.544434 2.55596 1.05785 1.60759 2.00621C0.659224 2.95458 0.145813 4.28403 0.145813 5.81527V11.3153C0.145813 12.8465 0.659224 14.176 1.60759 15.1243C2.41098 15.9277 3.48782 16.419 4.72915 16.5504V17.8511C4.72915 19.1369 6.1594 19.8896 7.21823 19.1844ZM4.91115 14.8314C5.79044 14.9245 6.45772 15.6662 6.45772 16.5504V17.6142L10.1671 15.1468C10.4507 14.9582 10.7838 14.8575 11.1244 14.8575H14.5833C15.7222 14.8575 16.5898 14.4823 17.1701 13.902C17.7503 13.3218 18.1256 12.4542 18.1256 11.3153V5.81527C18.1256 4.67633 17.7503 3.80874 17.1701 3.2285C16.5898 2.64826 15.7222 2.27301 14.5833 2.27301H5.41665C4.27771 2.27301 3.41012 2.64826 2.82988 3.2285C2.24964 3.80874 1.87438 4.67633 1.87438 5.81527V11.3153C1.87438 12.4542 2.24964 13.3218 2.82988 13.902C3.32479 14.3969 4.02076 14.7371 4.91115 14.8314Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.13065 6.95363C9.11297 6.96385 8.95202 7.07368 8.95202 7.54842V9.67224C8.95202 10.147 9.11297 10.2568 9.13065 10.267C9.14798 10.277 9.32262 10.3618 9.73276 10.1249C9.73284 10.1248 9.73268 10.1249 9.73276 10.1249L11.5652 9.0633C11.9753 8.82635 11.991 8.63158 11.991 8.61033C11.991 8.58908 11.9762 8.3948 11.5661 8.15785L9.733 7.09594C9.73287 7.09587 9.73313 7.09602 9.733 7.09594C9.32296 6.85915 9.14797 6.94361 9.13065 6.95363ZM8.27271 5.46947C9.00441 5.04651 9.86317 5.1913 10.5906 5.6116L12.4237 6.67351C12.4238 6.67358 12.4235 6.67344 12.4237 6.67351C13.1511 7.09395 13.7053 7.76576 13.7053 8.61033C13.7053 9.45487 13.1516 10.1264 12.4241 10.5469C12.424 10.547 12.4243 10.5468 12.4241 10.5469L10.5915 11.6086C9.86402 12.0289 9.00441 12.1741 8.27271 11.7512C7.54137 11.3284 7.23773 10.5122 7.23773 9.67224V7.54842C7.23773 6.70842 7.54137 5.89223 8.27271 5.46947Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function deforumSmallIcon() {
	return (
		<svg
			width="12"
			height="13"
			viewBox="0 0 20 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.59543 1.02473C10.3515 0.892457 12.1067 1.293 13.6316 2.17401C15.1565 3.05502 16.3801 4.37552 17.1426 5.96296C17.9052 7.5504 18.1711 9.33094 17.9057 11.0719C17.8378 11.5176 17.4214 11.8238 16.9757 11.7559C16.53 11.6879 16.2238 11.2716 16.2917 10.8259C16.5076 9.40964 16.2913 7.96122 15.671 6.66988C15.0507 5.37854 14.0553 4.30435 12.8148 3.58767C11.5744 2.871 10.1466 2.54517 8.71805 2.65277C7.28951 2.76037 5.92664 3.29639 4.80755 4.19079C3.68846 5.08519 2.86518 6.29636 2.44532 7.66604C2.02545 9.03573 2.02852 10.5002 2.45412 11.8681C2.87972 13.236 3.70805 14.4438 4.83088 15.3335C5.95371 16.2232 7.31881 16.7535 8.74779 16.8551C9.1975 16.8871 9.53614 17.2775 9.50416 17.7273C9.47218 18.177 9.08169 18.5156 8.63198 18.4836C6.87534 18.3587 5.19722 17.7068 3.81693 16.6131C2.43664 15.5194 1.41836 14.0347 0.895176 12.3532C0.371988 10.6716 0.368218 8.87129 0.88436 7.18754C1.4005 5.50379 2.41255 4.0149 3.78825 2.91541C5.16395 1.81593 6.83932 1.157 8.59543 1.02473Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.27126 8.0076C8.25274 8.0183 8.08413 8.13336 8.08413 8.63071V10.8557C8.08413 11.353 8.25274 11.4681 8.27126 11.4788C8.28942 11.4893 8.47237 11.578 8.90204 11.3298C8.90213 11.3298 8.90196 11.3299 8.90204 11.3298L10.8218 10.2177C11.2514 9.9695 11.2679 9.76545 11.2679 9.74319C11.2679 9.72092 11.2523 9.51739 10.8226 9.26916L8.9023 8.15669C8.90216 8.15661 8.90243 8.15676 8.9023 8.15669C8.47273 7.90862 8.28942 7.9971 8.27126 8.0076ZM7.37248 6.45276C8.13901 6.00966 9.03867 6.16134 9.80075 6.60166L11.7211 7.71414C11.7212 7.71421 11.721 7.71406 11.7211 7.71414C12.4832 8.1546 13.0638 8.8584 13.0638 9.74319C13.0638 10.6279 12.4836 11.3315 11.7216 11.772C11.7214 11.7721 11.7217 11.7719 11.7216 11.772L9.80165 12.8842C9.03956 13.3245 8.13901 13.4767 7.37248 13.0336C6.6063 12.5907 6.28821 11.7357 6.28821 10.8557V8.63071C6.28821 7.75071 6.6063 6.89566 7.37248 6.45276Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.5681 19.5453V14.7862C19.5361 13.8913 18.3799 13.8906 18.3477 14.7862V19.5453C18.3796 20.4402 19.5359 20.4409 19.5681 19.5453ZM16.1182 15.2215C15.9075 14.5465 15.3357 14.112 14.6628 14.1149C13.9889 14.1175 13.4206 14.5569 13.215 15.2342C13.2104 15.2492 12.2626 19.3962 12.2626 19.3962C12.1801 19.7571 12.4051 20.1167 12.7651 20.1994C13.1254 20.2821 13.4837 20.0565 13.5662 19.6955L13.7459 18.9089H15.62L15.8079 19.701C15.8919 20.064 16.2634 20.2845 16.6132 20.1981C16.9725 20.1125 17.1945 19.7509 17.109 19.3907C17.109 19.3907 16.1228 15.2364 16.1182 15.2215ZM14.0761 17.7759L14.5135 15.5102C14.5468 15.3974 14.6046 15.3355 14.6776 15.3351H14.6782C14.7514 15.3351 14.8077 15.3945 14.8416 15.5072L15.2965 17.7759H14.0761Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function restyleSmallIcon() {
	return (
		<svg
			width="12"
			height="13"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.98969 18.1324V13.5897C6.9592 12.7354 5.85553 12.7348 5.82478 13.5897V18.1324C5.85527 18.9867 6.95894 18.9874 6.98969 18.1324ZM3.69661 14.0052C3.49555 13.3609 2.94974 12.9462 2.30739 12.9488C1.66411 12.9514 1.12165 13.3708 0.925378 14.0173C0.921038 14.0317 0.0162514 17.9901 0.0162514 17.9901C-0.0624506 18.3346 0.152305 18.6779 0.4959 18.7568C0.839814 18.8358 1.18191 18.6204 1.26061 18.2759L1.43215 17.525H3.22105L3.40044 18.2811C3.48064 18.6276 3.83522 18.838 4.16914 18.7556C4.51207 18.6738 4.72398 18.3287 4.64237 17.9849C4.64237 17.9849 3.70105 14.0194 3.69661 14.0052ZM1.74733 16.4435L2.16487 14.2807C2.19666 14.1731 2.25183 14.114 2.32149 14.1136H2.32212C2.39197 14.1136 2.44567 14.1703 2.47809 14.2779L2.91224 16.4435H1.74733Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.09102 5.97377C2.09102 4.84207 2.32319 4.38133 2.61526 4.13847C2.95927 3.85241 3.64315 3.63991 5.08224 3.63991H10.9399C12.3789 3.63991 13.0628 3.85241 13.4068 4.13847C13.6989 4.38133 13.9311 4.84207 13.9311 5.97377V12.463C13.9311 13.5926 13.6976 14.0542 13.404 14.2978C13.0584 14.5847 12.3735 14.7969 10.9399 14.7969H8.19999V16.6184H10.9399C12.4258 16.6184 13.6919 16.426 14.5674 15.6995C15.4949 14.9296 15.7526 13.7689 15.7526 12.463V5.97377C15.7526 4.67007 15.4982 3.50848 14.5715 2.73788C13.6967 2.01047 12.4296 1.81836 10.9399 1.81836H5.08224C3.59251 1.81836 2.32539 2.01047 1.45062 2.73788C0.523893 3.50848 0.26947 4.67007 0.26947 5.97377V11.8238C0.704339 11.2711 1.34905 10.9101 2.09102 10.8648V5.97377Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.2383 5.97209C17.2381 5.97224 17.2385 5.97193 17.2383 5.97209L15.6856 7.21768V11.213L17.2395 12.4596L17.2413 12.461C17.4653 12.6419 17.5852 12.6583 17.6261 12.6567C17.6524 12.6212 17.7279 12.49 17.7279 12.1274V6.31093C17.7279 5.9443 17.6507 5.81364 17.6247 5.7794C17.5848 5.77707 17.4644 5.79161 17.2383 5.97209ZM17.64 5.78192C17.64 5.782 17.639 5.78177 17.6371 5.78099ZM17.6425 12.6542C17.6425 12.6543 17.6415 12.6547 17.6393 12.6552ZM18.3252 4.35507C18.9698 4.7401 19.1963 5.54266 19.1963 6.31093V12.1274C19.1963 12.8949 18.9702 13.6992 18.3237 14.0832C17.6636 14.4754 16.9333 14.2156 16.3734 13.764C16.3731 13.7637 16.3737 13.7642 16.3734 13.764L14.5188 12.2762C14.3293 12.1241 14.2172 11.8816 14.2172 11.6236V6.80709C14.2172 6.54908 14.3293 6.3066 14.5188 6.15456L16.3742 4.6661C16.9354 4.21779 17.6668 3.96186 18.3252 4.35507Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function photoAiSmallIcon() {
	return (
		<svg
			width="12"
			height="13"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M5.9019 7.15768C6.77009 7.15768 7.4739 6.45387 7.4739 5.58568C7.4739 4.71748 6.77009 4.01367 5.9019 4.01367C5.03371 4.01367 4.3299 4.71748 4.3299 5.58568C4.3299 6.45387 5.03371 7.15768 5.9019 7.15768Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.3537 18.7797V13.7827C19.3202 12.843 18.1061 12.8423 18.0723 13.7827V18.7797C18.1058 19.7194 19.3199 19.7201 19.3537 18.7797ZM15.7313 14.2397C15.5101 13.531 14.9098 13.0748 14.2032 13.0778C13.4956 13.0806 12.8989 13.5419 12.683 14.2531C12.6782 14.2689 11.6829 18.6231 11.6829 18.6231C11.5963 19.0021 11.8326 19.3797 12.2105 19.4665C12.5888 19.5534 12.9651 19.3165 13.0517 18.9375L13.2404 18.1115H15.2082L15.4055 18.9432C15.4937 19.3244 15.8838 19.5559 16.2511 19.4652C16.6283 19.3752 16.8614 18.9956 16.7717 18.6174C16.7717 18.6174 15.7362 14.2554 15.7313 14.2397ZM13.5871 16.9219L14.0464 14.5428C14.0814 14.4244 14.1421 14.3594 14.2187 14.359H14.2194C14.2962 14.359 14.3553 14.4214 14.3909 14.5397L14.8685 16.9219H13.5871Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.26483 2.13373C3.45154 0.947031 5.20653 0.515137 7.39247 0.515137H12.4341C14.6201 0.515137 16.3751 0.947031 17.5618 2.13373C18.7485 3.32043 19.1804 5.07543 19.1804 7.26137V9.81863V9.8219V11.8049C19.0841 11.7889 18.9855 11.7807 18.8852 11.7806C18.3049 11.7805 17.7815 12.0558 17.4503 12.5123C17.4513 12.4436 17.4518 12.3738 17.4518 12.303V10.2107L16.3989 9.2844L16.3989 9.28438C16.0811 9.00476 15.5294 9.00476 15.2116 9.28438L15.2113 9.28464L11.7757 12.3047L11.7754 12.3049C10.8047 13.1587 9.2753 13.1586 8.30474 12.3047L8.29739 12.2982L8.29743 12.2982L8.02919 12.0567C7.74572 11.81 7.24426 11.7763 6.9124 12.0041L6.91214 12.0043L2.84055 14.8045C2.79801 14.8337 2.75378 14.8586 2.70838 14.8793C2.89654 15.4498 3.1599 15.8812 3.48712 16.2084C4.19104 16.9123 5.37702 17.3207 7.39247 17.3207H10.65L10.3807 18.498C10.3383 18.6833 10.3252 18.8687 10.3382 19.0493H7.39247C5.20653 19.0493 3.45154 18.6174 2.26483 17.4307C1.07813 16.244 0.64624 14.489 0.64624 12.303V7.26137C0.64624 5.07543 1.07813 3.32043 2.26483 2.13373ZM17.4518 7.26137V7.912C16.4788 7.13343 15.0116 7.15822 14.0701 7.98636L14.0697 7.98663L10.6342 11.0067L10.6339 11.0069C10.3171 11.2857 9.76782 11.2865 9.44956 11.0095L9.18134 10.7681L9.18137 10.768L9.17409 10.7616C8.28428 9.97855 6.90511 9.91176 5.93314 10.5797L5.93289 10.5799L2.39337 13.0141C2.38107 12.7893 2.37481 12.5525 2.37481 12.303V7.26137C2.37481 5.24592 2.78319 4.05994 3.48712 3.35602C4.19104 2.65209 5.37702 2.24371 7.39247 2.24371H12.4341C14.4496 2.24371 15.6356 2.65209 16.3395 3.35602C17.0434 4.05994 17.4518 5.24592 17.4518 7.26137Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function textToImageSmallIcon() {
	return (
		<svg
			width="12"
			height="13"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.77701 15.6575C5.26551 15.7092 5.63622 16.1212 5.63622 16.6124V17.9263C5.63622 18.4515 6.2208 18.7649 6.65777 18.4738L6.65827 18.4735L10.6039 15.8489C10.7615 15.7441 10.9465 15.6882 11.1358 15.6882H14.6296C15.9584 15.6882 17.0446 15.2464 17.7981 14.4929C18.5515 13.7395 18.9934 12.6532 18.9934 11.3245V5.7689C18.9934 4.44014 18.5515 3.35385 17.7981 2.60042C17.0446 1.84698 15.9584 1.40514 14.6296 1.40514H5.37034C4.04158 1.40514 2.9553 1.84698 2.20186 2.60042C1.44843 3.35385 1.00659 4.44014 1.00659 5.7689V11.3245C1.00659 12.6532 1.44843 13.7395 2.20186 14.4929C2.84198 15.1331 3.71811 15.5454 4.77701 15.6575Z"
				stroke="var(--icon-color)"
				strokeWidth="1.92063"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19.2591 7.68555L14.9384 10.8849C13.5176 11.937 11.6316 12.1177 10.0369 11.3545V11.3545C8.50731 10.6225 6.70427 10.7568 5.30007 11.7073L1.6665 14.167"
				stroke="var(--icon-color)"
				strokeWidth="1.92063"
				strokeMiterlimit="10"
				strokeLinejoin="round"
			/>
			<path
				d="M12.101 7.49099C13.059 7.49099 13.8357 6.71432 13.8357 5.75624C13.8357 4.79816 13.059 4.02148 12.101 4.02148C11.1429 4.02148 10.3662 4.79816 10.3662 5.75624C10.3662 6.71432 11.1429 7.49099 12.101 7.49099Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function textToVideoSmallIcon() {
	return (
		<svg
			width="12"
			height="12"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.21823 19.1844L11.1244 16.5861H14.5833C16.1145 16.5861 17.444 16.0727 18.3924 15.1243C19.3407 14.176 19.8541 12.8465 19.8541 11.3153V5.81527C19.8541 4.28403 19.3407 2.95458 18.3924 2.00621C17.444 1.05785 16.1145 0.544434 14.5833 0.544434H5.41665C3.88541 0.544434 2.55596 1.05785 1.60759 2.00621C0.659224 2.95458 0.145813 4.28403 0.145813 5.81527V11.3153C0.145813 12.8465 0.659224 14.176 1.60759 15.1243C2.41098 15.9277 3.48782 16.419 4.72915 16.5504V17.8511C4.72915 19.1369 6.1594 19.8896 7.21823 19.1844ZM4.91115 14.8314C5.79044 14.9245 6.45772 15.6662 6.45772 16.5504V17.6142L10.1671 15.1468C10.4507 14.9582 10.7838 14.8575 11.1244 14.8575H14.5833C15.7222 14.8575 16.5898 14.4823 17.1701 13.902C17.7503 13.3218 18.1256 12.4542 18.1256 11.3153V5.81527C18.1256 4.67633 17.7503 3.80874 17.1701 3.2285C16.5898 2.64826 15.7222 2.27301 14.5833 2.27301H5.41665C4.27771 2.27301 3.41012 2.64826 2.82988 3.2285C2.24964 3.80874 1.87438 4.67633 1.87438 5.81527V11.3153C1.87438 12.4542 2.24964 13.3218 2.82988 13.902C3.32479 14.3969 4.02076 14.7371 4.91115 14.8314Z"
				fill="var(--icon-color)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.13065 6.95363C9.11297 6.96385 8.95202 7.07368 8.95202 7.54842V9.67224C8.95202 10.147 9.11297 10.2568 9.13065 10.267C9.14798 10.277 9.32262 10.3618 9.73276 10.1249C9.73284 10.1248 9.73268 10.1249 9.73276 10.1249L11.5652 9.0633C11.9753 8.82635 11.991 8.63158 11.991 8.61033C11.991 8.58908 11.9762 8.3948 11.5661 8.15785L9.733 7.09594C9.73287 7.09587 9.73313 7.09602 9.733 7.09594C9.32296 6.85915 9.14797 6.94361 9.13065 6.95363ZM8.27271 5.46947C9.00441 5.04651 9.86317 5.1913 10.5906 5.6116L12.4237 6.67351C12.4238 6.67358 12.4235 6.67344 12.4237 6.67351C13.1511 7.09395 13.7053 7.76576 13.7053 8.61033C13.7053 9.45487 13.1516 10.1264 12.4241 10.5469C12.424 10.547 12.4243 10.5468 12.4241 10.5469L10.5915 11.6086C9.86402 12.0289 9.00441 12.1741 8.27271 11.7512C7.54137 11.3284 7.23773 10.5122 7.23773 9.67224V7.54842C7.23773 6.70842 7.54137 5.89223 8.27271 5.46947Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function enhanceIcon() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15.6723 5.71724C16.2525 5.13703 16.6673 4.42758 16.9774 3.57836C17.2875 4.42758 17.7022 5.13703 18.2824 5.71724C18.8626 6.29745 19.5721 6.71217 20.4213 7.02228C19.5721 7.33239 18.8626 7.74711 18.2824 8.32732C17.7022 8.90753 17.2875 9.61698 16.9774 10.4662C16.6672 9.61698 16.2525 8.90753 15.6723 8.32732C15.0921 7.74711 14.3827 7.33238 13.5334 7.02228C14.3827 6.71217 15.0921 6.29745 15.6723 5.71724Z"
				fill="var(--icon-color)"
				stroke="var(--icon-color)"
				strokeWidth="1.5"
			/>
			<path
				d="M19.4983 14.145C19.666 13.9773 19.809 13.7932 19.9319 13.5938C20.0547 13.7932 20.1977 13.9773 20.3654 14.145C20.5332 14.3128 20.7172 14.4558 20.9166 14.5786C20.7172 14.7015 20.5332 14.8445 20.3654 15.0122C20.1977 15.1799 20.0547 15.364 19.9319 15.5634C19.809 15.364 19.666 15.1799 19.4983 15.0122C19.3305 14.8445 19.1465 14.7015 18.9471 14.5786C19.1465 14.4558 19.3305 14.3128 19.4983 14.145Z"
				stroke="var(--icon-color)"
				strokeWidth="1.5"
			/>
			<path
				d="M7.87844 4.37355C8.04616 4.20582 8.18916 4.02175 8.31201 3.82234C8.43486 4.02175 8.57786 4.20582 8.74559 4.37355C8.91332 4.54128 9.09739 4.68428 9.2968 4.80713C9.09739 4.92998 8.91332 5.07297 8.74559 5.2407C8.57786 5.40843 8.43486 5.5925 8.31201 5.79192C8.18916 5.5925 8.04617 5.40843 7.87844 5.2407C7.71071 5.07298 7.52664 4.92998 7.32723 4.80713C7.52664 4.68428 7.71071 4.54128 7.87844 4.37355Z"
				stroke="var(--icon-color)"
				strokeWidth="1.5"
			/>
			<path
				d="M12.6386 9.50391C13.618 9.97904 14.2847 10.6459 14.7597 11.6254L4.96808 21.417C4.57755 21.8076 3.94439 21.8076 3.55386 21.417L2.84676 20.7099C2.45623 20.3194 2.45623 19.6862 2.84676 19.2957L12.6386 9.50391Z"
				fill="var(--icon-color)"
			/>
		</svg>
	)
}

export function allIcon() {
	return (
		<svg
			width="22"
			height="23"
			viewBox="0 0 22 23"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g id="Default/Grid">
				<g id="Group_1000002576">
					<rect
						id="Rectangle_602"
						x="3.07617"
						y="3.53711"
						width="6.41488"
						height="6.41488"
						rx="3.20744"
						stroke="var(--icon-color)"
						strokeWidth="1.5"
					/>
					<rect
						id="Rectangle_604"
						x="3.07617"
						y="13.0488"
						width="6.415"
						height="6.415"
						rx="3.2075"
						stroke="var(--icon-color)"
						strokeWidth="1.5"
					/>
					<rect
						id="Rectangle_603"
						x="12.5088"
						y="3.53711"
						width="6.41488"
						height="6.41488"
						rx="3.20744"
						stroke="var(--icon-color)"
						strokeWidth="1.5"
					/>
					<rect
						id="Rectangle_605"
						x="12.5088"
						y="13.0488"
						width="6.415"
						height="6.415"
						rx="3.2075"
						stroke="var(--icon-color)"
						strokeWidth="1.5"
					/>
				</g>
			</g>
		</svg>
	)
}

export const DownArrowsIcon = () => {
	return (
		<>
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M5.83366 5L10.0003 9.16667L14.167 5"
					stroke="var(--icon-color)"
					strokeWidth="1.66667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M5.83366 10.832L10.0003 14.9987L14.167 10.832"
					stroke="var(--icon-color)"
					strokeWidth="1.66667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</>
	)
}

export const DownArrowsDesktopIcon = () => {
	return (
		<>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M6 17L11 12L6 7"
					stroke="var(--icon-color)"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13 17L18 12L13 7"
					stroke="var(--icon-color)"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</>
	)
}

export const PlusIcon = () => {
	return (
		<>
			<svg
				width="12"
				height="12"
				viewBox="0 0 12 12"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6 1C6.30683 1 6.55556 1.24873 6.55556 1.55556V5.44444H10.4444C10.7513 5.44444 11 5.69318 11 6C11 6.30683 10.7513 6.55556 10.4444 6.55556H6.55556V10.4444C6.55556 10.7513 6.30683 11 6 11C5.69318 11 5.44444 10.7513 5.44444 10.4444V6.55556H1.55556C1.24873 6.55556 1 6.30683 1 6C1 5.69318 1.24873 5.44444 1.55556 5.44444H5.44444V1.55556C5.44444 1.24873 5.69318 1 6 1Z"
					fill="var(--icon-color)"
				/>
			</svg>
		</>
	)
}
